module.exports = __webpack_public_path__ + "img/player-configuration.34881c99.png";